import React from 'react';
import { useGameQuality } from '@/app/providers/GameQualityProvider';
import ToggleFFXIV from './ToggleFFXIV';
import TooltipWithIconFFXIV from './TooltipWithIconFFXIV';
import { useTranslation } from '@/hooks/useTranslation';

const GameQualitySelector = () => {
    const { settings, setSettings } = useGameQuality();
    const { t } = useTranslation();

    const handleQuality = (value: boolean) => {
        setSettings({ backdropBlur: value });
    };

    return (
        <div className="space-y-1">
            <div className="flex justify-between items-center gap-5">
                <div className="text-[#EEEEEE] text-lg text-shadow shadow-black/70">{t('settings.gameQuality.title')}</div>
                <TooltipWithIconFFXIV
                    position="left"
                    text={t('settings.gameQuality.tooltip')}
                />
            </div>
            <div className="ml-3 flex flex-col gap-0.5">
                <ToggleFFXIV
                    value={!settings.backdropBlur}
                    onChange={() => handleQuality(false)}
                    text={t('settings.gameQuality.performance')}
                />
                <ToggleFFXIV
                    value={settings.backdropBlur}
                    onChange={() => handleQuality(true)}
                    text={t('settings.gameQuality.quality')}
                />
            </div>
        </div>
    );
};

export default GameQualitySelector;